export default __webpack_public_path__ + "static/media/Premiumspacepromax.53a8672c.webp";